import './App.css';

import { HashRouter, Routes, Route } from 'react-router-dom';  
import {api_base_url} from './common/Constants';
import AOS from "aos";
import 'aos/dist/aos.css';

import Home from './pages/Home';
import About from './pages/About'; 
import Certificates from './pages/Certificates';  
import Projects from './pages/Projects';
import ProjectInfo from './pages/ProjectInfo';
import Clients from './pages/Clients';
import People from './pages/People';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ApplyNow from './pages/ApplyNow';
import Blog from './pages/Blog';
import BlogInfo from './pages/BlogInfo';
import ServiceList from './pages/ServiceList'; 
import Explore from './pages/Explore'; 
import Cms from './pages/Cms';
import Portals from './pages/Portals';
import Search from './pages/Search';
import Email from './pages/Email';
import Careers from './pages/Careers';  
import ScrollToTop from './pages/ScrollToTop'; 
import React, { useEffect, useState } from 'react';


function App() {

  const [loading, setLoading] = useState(true);

    useEffect(() => {
    AOS.init({
      duration: 1000,     // animation duration
      once: true,         // animate only once
      easing: "ease-in-out",
      offset: 100,
    });
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(api_base_url+"get-all-data");
        const data = await res.json();
        
        localStorage.setItem("content", JSON.stringify(data.content));
        localStorage.setItem("slugcontent", JSON.stringify(data.slugcontent));
        localStorage.setItem("abudhabi", JSON.stringify(data.abudhabi));
        localStorage.setItem("settings", JSON.stringify(data.settings));
        localStorage.setItem("banners", JSON.stringify(data.banners)); 
        localStorage.setItem("careers", JSON.stringify(data.careers)); 
        localStorage.setItem("home_banners", JSON.stringify(data.home_banners)); 
        localStorage.setItem("page_banners", JSON.stringify(data.pagebanners)); 
        localStorage.setItem("pagecontents", JSON.stringify(data.pagecontents)); 
        localStorage.setItem("projects", JSON.stringify(data.projects));
        localStorage.setItem("certificates", JSON.stringify(data.certificates));
        localStorage.setItem("services", JSON.stringify(data.services));
        localStorage.setItem("project_list", JSON.stringify(data.projectlists)); 
        localStorage.setItem("clients", JSON.stringify(data.clients)); 
        localStorage.setItem("partners", JSON.stringify(data.partners)); 
        localStorage.setItem("people", JSON.stringify(data.people)); 
        localStorage.setItem("project_types", JSON.stringify(data.projecttypes));  
        localStorage.setItem("services", JSON.stringify(data.services)); 
        localStorage.setItem("categories", JSON.stringify(data.categories)); 
        localStorage.setItem("divisions_slug", JSON.stringify(data.divisions_slug)); 
        localStorage.setItem("metas", JSON.stringify(data.metas)); 
        localStorage.setItem("locations", JSON.stringify(data.locations)); 
        localStorage.setItem("portals", JSON.stringify(data.portals));  
        localStorage.setItem("ecosystems", JSON.stringify(data.ecosystems)); 
        localStorage.setItem("companies", JSON.stringify(data.companies)); 
        localStorage.setItem("companiesid", JSON.stringify(data.companiesid)); 
        localStorage.setItem("blogs", JSON.stringify(data.blogs)); 
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchSettings();
  }, []);
  
   
  if (loading) return <div class="loader">Loading...</div>;
 
  return (
    <div>  
      <HashRouter>
        <ScrollToTop />
      <Routes>
      <Route  path="/" element={<Home />} > </Route>
      <Route  path="/about-us" element={<About />} > </Route>    
      <Route  path="/service-category/:id" element={<ServiceList />} > </Route> 
      <Route  path="/services/:id" element={<Services />} > </Route> 
      <Route  path="/explore/:id" element={<Explore />} > </Route> 
      <Route  path="/projects" element={<Projects />} > </Route>
      <Route  path="/stakeholders/:id" element={<Clients />} > </Route> 
      <Route  path="/stakeholders/people" element={<People />} > </Route>
      <Route  path="/contact-us" element={<Contact />} > </Route>
      <Route  path="/downloads" element={<Certificates />} > </Route> 
      <Route  path="/project-info/:id" element={<ProjectInfo />} > </Route>  
      <Route  path="/news" element={<Blog />} > </Route> 
      <Route  path="/news-info/:id" element={<BlogInfo />} > </Route> 
      <Route  path="/apply-now/:id" element={<ApplyNow />} > </Route>  
      <Route  path="/careers" element={<Careers />} > </Route> 
      <Route  path="/portals" element={<Portals />} > </Route> 
      <Route  path="/contact-us" element={<Contact />} > </Route> 
      <Route  path="/apply-now/:id" element={<ApplyNow />} > </Route> 
      <Route  path="/email" element={<Email />} > </Route> 
      <Route  path="/:slug" element={<Cms />} > </Route> 
      <Route  path="/search" element={<Search />} > </Route> 
      
      </Routes>
    
    </HashRouter> 
  </div>
     
  );
}

export default App;